import SsgFallback from '@components/SsgFallback'
import getWebsiteIdFromDomain from '@data/queries/website/websiteIdFromDomain'
import getWebsitePublication from '@data/queries/website/websitePublications.main'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import Layout from '@page-components/Layout'
import Publication from '@page-components/Publication'
import {InferGetStaticPropsType} from 'next'
import {useRouter} from 'next/router'

export default function PublicationPage(props: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  if (router.isFallback) {
    return <SsgFallback />
  }

  return (
    <Layout >
      <Publication publication={props.publication} website={props.website} />
    </Layout>
  )
}

export const getStaticProps = async context => {
  const websiteId = await getWebsiteIdFromDomain(context.params.hostname)
  const {publication, website} = await getWebsitePublication(
    websiteId,
    context.params.publicationId
  )
  return {
    props: {
      ...(await websiteSSRTranslations(context.params.hostname)),
      websiteId,
      website,
      publication,
      revalidate: 60 // 1 minute for now. In the future, extend this. (We need to add these to the cache invalidation query at Justo API)
    }
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
